import { useAuthUserStore } from "@/stores/authUser/store"

export default async function getAuthUser() {
  const authUserStore = useAuthUserStore()
  await authUserStore.getAuthUser()
}
